export default __webpack_public_path__ + "static/media/MD.fe759e04.svg";